import axios from 'axios';
import { message } from 'antd';
import { useUiStore } from './stores/uiStore';

let initialized = false;

export const setupAxios = () => {
    if (initialized) return;
    initialized = true;

    axios.defaults.baseURL = process.env.REACT_APP_MAINURL;

    axios.interceptors.request.use(
        (config) => {
            useUiStore.getState().startLoading();

            const token = localStorage.getItem('token');
            if (token) {
                config.headers = config.headers ?? {};
                config.headers.Authorization = `Bearer ${token}`;
            }

            return config;
        },
        (error) => {
            useUiStore.getState().stopLoading();
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        (response) => {
            useUiStore.getState().stopLoading();
            return response;
        },
        (error) => {
            useUiStore.getState().stopLoading();

            const status = error?.response?.status;
            if (status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');

                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            } else {
                // Markaziy xato ko'rsatish — .catch yozilmagan chaqiruvlar ham
                // endi jim yiqilmaydi (silent failure oldini oladi)
                const data = error?.response?.data;
                let msg = data?.message || error?.message || "Server bilan bog'lanishда xatolik";

                // Laravel validatsiya (422) — birinchi xato matnini olamiz
                if (data?.errors && typeof data.errors === 'object') {
                    const first = Object.values(data.errors)[0];
                    if (Array.isArray(first) && first[0]) {
                        msg = first[0];
                    }
                }

                message.error(msg);
            }

            return Promise.reject(error);
        }
    );
};
